import { defineComponent, ref, onBeforeMount } from 'vue'
import Breadcrumbs from '@/components/breadcrumbs'
import FeedbackModal from '@/components/feedback-modal'
import RightMenu from '@/components/right-menu'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu/index.tsx'
import axios from '@/axios'
import { host } from '@/const'
import './style.sass'
import BetaVersion from "@/components/beta-version";

export default defineComponent({
  setup () {
    const isFeebbackModal = ref(false)
    const contacts = ref([])

    onBeforeMount(async () => {
      contacts.value = (await axios.get(`${host}/api/v1/contacts`, {})).data.items
    })

    function openFeedbackModal () {
      isFeebbackModal.value = true
    }

    function closeFeedbackModal () {
      isFeebbackModal.value = false
    }

    return () => (
      <div class="connect-company-page">
        <Breadcrumbs items={[{ name: 'Главная', link: '/' }, { name: 'Мои документы', link: '#' }]}/>
        <BetaVersion />
        <h1 class="page-title">Связаться с компанией</h1>
        <div class="main-content-two-columns">
          <div class="contacts-connect">
            <div>
              <p class="headline">Контакты компании</p>
              {contacts.value
                ? (
                  <ul class="main-contacts-list">
                    {contacts.value.map((item: Record<string, string>) =>
                      <li class="mail">
                        <span class="desc">{item.title}</span>
                        <a href={`mailto:${item.value}`} class="info">{item.value}</a>
                      </li>
                    )}
                  </ul>
                )
                : null }
            </div>
            <div class="communication">
              <a class="call" href="tel:88003331148">Позвонить</a>
              <a class="complaint" onClick={() => openFeedbackModal()}>Оставить жалобу</a>
            </div>
          </div>
          <div class="main-content-two-columns-right">
            <div class="main-content-two-columns-right-elem-sticky">
              <RightMenu/>
              <Logout/>
              <MobileMenu/>
            </div>
          </div>
        </div>
        {isFeebbackModal.value ? <FeedbackModal closeFeedbackModal={() => closeFeedbackModal()} /> : null}
      </div>
    )
  }
})